// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ConfiguracoesSistema_GetByNameAndFranquiaIdResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET
 * /config/configuracoes_sistema/get_by_name_and_franquia_id/{nome}/{franquia_id}.
 *
 * dados is a single joined config row with the franchise override applied
 * (Configuracoes_sistema_model::get_by_name_and_franquia_id), or null when not
 * found. The row carries { nome, franquia_id, valor_padrao, valor } where the
 * model falls back $valor to $valor_padrao when the franchise has no override.
 * The model returns a raw stdClass from `->row()`, passed through verbatim to
 * preserve the legacy wire shape (object-or-null with success:true).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ConfiguracoesSistema_GetByNameAndFranquiaIdResponseDados = object;

export type ConfiguracoesSistema_GetByNameAndFranquiaIdResponse = ApiResponse<ConfiguracoesSistema_GetByNameAndFranquiaIdResponseDados>;

registerResponseContract('ConfiguracoesSistema_GetByNameAndFranquiaIdResponse', {})
